export enum ImageTypeEnum {
  BACKGROUND = "background",
  AVATAR = "avatar",
  OFFER_REQUEST = "offer-request",
  BOTTLE = "bottle",
  LABEL = "label",
  ORIGINAL = "original",
}
